/* Cadar GR — made-to-order (κατά παραγγελία) configurator.
   Same pricing as the Cadar RO configurator (formula_v 1):
     exact = (L × W / 10 000) × rate × (1 + markup)
     step  = max(min, ceil(exact / step) × step)   → index of the ladder variant
   The ladder variant's own price (EUR) is what the customer sees and pays.
   Shapes (as on the UK configurator): the mattress is priced on the rectangle that
   encloses the shape (L × W) and a fixed shape surcharge is added as its own cart
   line (surcharge product); extra pieces add one "extra piece" line each. */
(function () {
  'use strict';

  function money(cents) {
    return window.themeFormatMoney ? window.themeFormatMoney(cents) : (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function pad3(n) { return String(n).padStart ? String(n).padStart(3, '0') : ('00' + n).slice(-3); }
  function int(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }

  function init(root) {
    var section = root.closest('[data-section-id]');
    var dataEl = document.querySelector('[data-mtm-data="' + section.dataset.sectionId + '"]');
    if (!dataEl) return;
    var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!D.groups || !D.groups.length) return;
    var S = D.strings;
    var form = root.querySelector('[data-mtm-form]');
    var q = function (sel) { return root.querySelector(sel); };
    var qa = function (sel) { return root.querySelectorAll(sel); };
    var G = {}; D.groups.forEach(function (g) { G[g.cfg.group] = g; });
    var cur = D.groups.filter(function (g) { return g.handle === D.current; })[0] || D.groups[0];
    var lim = cur.cfg.limits;
    var SH = {}; (D.shapes || []).forEach(function (s) { SH[s.key] = s; });
    if (!SH.rect) SH.rect = { key: 'rect', label: S.rect || '', cents: 0, variant: null, foamOnly: false };
    var st = { g: cur.cfg.group, sku: cur.cfg['default'], l: 200, w: 140, shape: 'rect', pos: 'fr', n: 1, p: {}, busy: false };
    var PARAMS = { corner: ['c', 'd'], cutout: ['nw', 'nh'], taper: ['tw'], rounded: ['r'], twowidth: ['w2', 't'] };

    /* deep link: ?l=200&w=140&model=…&shape=taper&tw=40&n=2&pos=fr */
    var qs = null;
    try {
      qs = new URLSearchParams(location.search);
      if (qs.get('l')) st.l = int(qs.get('l')) || st.l;
      if (qs.get('w')) st.w = int(qs.get('w')) || st.w;
      if (qs.get('shape') && SH[qs.get('shape')]) st.shape = qs.get('shape');
      if (qs.get('pos') && /^(fr|fl|hr|hl)$/.test(qs.get('pos'))) st.pos = qs.get('pos');
      if (qs.get('n')) st.n = Math.max(1, Math.min(D.maxPieces || 3, int(qs.get('n'))));
      ['c', 'd', 'nw', 'nh', 'tw', 'r', 'w2', 't'].forEach(function (k) { if (qs.get(k)) st.p[k] = int(qs.get(k)); });
      var want = qs.get('model');
      if (want) {
        D.groups.forEach(function (g) { g.cfg.models.forEach(function (m) { if (m.sku === want) { st.g = g.cfg.group; st.sku = m.sku; } }); });
      } else {
        var sd = JSON.parse(sessionStorage.getItem('cdrDims') || 'null');
        if (sd && !qs.get('l') && !qs.get('w')) { if (sd.l >= lim.minL && sd.l <= lim.maxL) st.l = sd.l; if (sd.w >= lim.minW && sd.w <= lim.maxW) st.w = sd.w; }
      }
    } catch (e) {}

    function shape() { return SH[st.shape] || SH.rect; }
    function foamOnly() { return st.shape !== 'rect' && shape().foamOnly || st.n > 1; }
    function allowed(g) { return !foamOnly() || (D.shapeGroups || []).indexOf(g) !== -1; }
    function group() { return G[st.g]; }
    function model() {
      var ms = group().cfg.models;
      return ms.filter(function (m) { return m.sku === st.sku; })[0] || ms.filter(function (m) { return m.sku === group().cfg['default']; })[0] || ms[0];
    }
    function L() { return st.shape === 'round' ? st.w : st.l; }
    function area() { return L() * st.w / 10000; }
    function shapeArea() {
      var l = L(), w = st.w, p = st.p, a = l * w;
      if (st.shape === 'corner') a -= p.c * p.d / 2;
      else if (st.shape === 'cutout') a -= p.nw * p.nh;
      else if (st.shape === 'taper') a = (w + p.tw) / 2 * l;
      else if (st.shape === 'round') a = Math.PI * w * w / 4;
      else if (st.shape === 'rounded') a -= (4 - Math.PI) * p.r * p.r;
      else if (st.shape === 'twowidth') a = w * p.t + p.w2 * (l - p.t);
      return a / 10000;
    }
    function quote(g, m) {
      var c = g.cfg, exact = area() * m.rate * (1 + c.markup);
      var t = Math.max(c.min, Math.ceil(exact / c.step) * c.step), idx = (t - c.min) / c.step + 1;
      var tier = c.tiers[idx - 1];
      if (!tier) return null;
      var live = g.live && g.live[String(tier[0])];
      return { idx: idx, id: tier[0], cents: typeof live === 'number' ? live : tier[1], exact: exact };
    }
    function dimsOk() {
      if (st.shape === 'round') return st.w >= Math.max(lim.minW, lim.minL) && st.w <= Math.min(lim.maxW, lim.maxL);
      return st.l >= lim.minL && st.l <= lim.maxL && st.w >= lim.minW && st.w <= lim.maxW;
    }
    /* parameter ranges, in cm, for the current L × W */
    function ranges() {
      var l = L(), w = st.w;
      return {
        c: [10, l - 20], d: [10, w - 20], nw: [10, w - 20], nh: [10, l - 20],
        tw: [20, w - 10], r: [5, Math.floor(Math.min(l, w) / 2)], w2: [30, w - 10], t: [20, l - 20]
      };
    }
    function defaults() {
      var l = L(), w = st.w;
      return { c: Math.round(l * 0.25), d: Math.round(w * 0.3), nw: Math.round(w * 0.33), nh: Math.round(l * 0.25),
               tw: Math.round(w * 0.3), r: 20, w2: Math.round(w * 0.8), t: Math.round(l * 0.5) };
    }
    function paramsOk() {
      var keys = PARAMS[st.shape] || [], R = ranges();
      return keys.every(function (k) { var v = st.p[k]; return v >= R[k][0] && v <= R[k][1]; });
    }
    function valid() { return dimsOk() && paramsOk(); }

    function renderModels() {
      var box = q('[data-mtm-models]'); box.textContent = '';
      var g = group();
      g.cfg.models.forEach(function (m) {
        var lab = document.createElement('label'); lab.className = 'opt-card';
        var i = document.createElement('input'); i.type = 'radio'; i.name = 'mtm-model'; i.value = m.sku; i.checked = m.sku === model().sku;
        i.addEventListener('change', function () { st.sku = m.sku; update(); });
        var dot = document.createElement('span'); dot.className = 'opt-card__dot'; dot.setAttribute('aria-hidden', 'true');
        var tx = document.createElement('span');
        var nm = document.createElement('strong'); nm.textContent = m.name; tx.appendChild(nm);
        var sub = document.createElement('span'); sub.className = 'opt-card__sub';
        sub.textContent = S.height + ' ' + m.h + ' ' + S.cm + ' · ';
        var a = document.createElement('a'); a.href = m.url; a.target = '_blank'; a.rel = 'noopener'; a.textContent = S.seeModel;
        sub.appendChild(a); tx.appendChild(sub);
        var pr = document.createElement('span'); pr.className = 'opt-card__price num'; pr.setAttribute('data-mtm-model-price', m.sku);
        lab.appendChild(i); lab.appendChild(dot); lab.appendChild(tx); lab.appendChild(pr);
        box.appendChild(lab);
      });
    }

    /* outline of the shape in cm (x across the width, y along the length, head at y = 0) */
    function outline(l, w, p) {
      var pts = null;
      if (st.shape === 'corner') pts = [[0, 0], [w, 0], [w, l - p.c], [w - p.d, l], [0, l]];
      else if (st.shape === 'cutout') pts = [[0, 0], [w, 0], [w, l - p.nh], [w - p.nw, l - p.nh], [w - p.nw, l], [0, l]];
      else if (st.shape === 'taper') pts = [[(w - p.tw) / 2, 0], [(w + p.tw) / 2, 0], [w, l], [0, l]];
      else if (st.shape === 'twowidth') { var i = (w - p.w2) / 2; pts = [[0, 0], [w, 0], [w, p.t], [w - i, p.t], [w - i, l], [i, l], [i, p.t], [0, p.t]]; }
      if (pts && (st.shape === 'corner' || st.shape === 'cutout')) {
        var fx = st.pos === 'fl' || st.pos === 'hl', fy = st.pos === 'hr' || st.pos === 'hl';
        pts = pts.map(function (pt) { return [fx ? w - pt[0] : pt[0], fy ? l - pt[1] : pt[1]]; });
      }
      return pts;
    }
    function drawing(l, w, p) {
      var VW = 360, VH = 280, P = 44, sc = Math.min((VW - P * 2) / w, (VH - P * 2) / l), bw = w * sc, bh = l * sc, x = (VW - bw) / 2, y = (VH - bh) / 2;
      function f(n) { return n.toFixed(1); }
      var body, sty = ' fill="var(--bg-alt)" stroke="var(--text)" stroke-width="2" stroke-linejoin="round"';
      var pts = outline(l, w, p);
      if (st.shape === 'round') body = '<circle cx="' + f(x + bw / 2) + '" cy="' + f(y + bh / 2) + '" r="' + f(bw / 2) + '"' + sty + '/>';
      else if (pts) body = '<path d="M' + pts.map(function (pt) { return f(x + pt[0] * sc) + ' ' + f(y + pt[1] * sc); }).join('L') + 'Z"' + sty + '/>';
      else body = '<rect x="' + f(x) + '" y="' + f(y) + '" width="' + f(bw) + '" height="' + f(bh) + '" rx="' + f(st.shape === 'rounded' ? p.r * sc : 4) + '"' + sty + '/>';
      var extra = '';
      for (var k = 1; k < st.n; k++) {
        var lx = x + bw * k / st.n;
        extra += '<line x1="' + f(lx) + '" y1="' + f(y) + '" x2="' + f(lx) + '" y2="' + f(y + bh) + '" stroke="var(--accent)" stroke-width="1.4" stroke-dasharray="6 3"/>';
      }
      var note = '';
      if (st.shape === 'corner') note = 'C ' + p.c + ' · D ' + p.d;
      else if (st.shape === 'cutout') note = p.nw + ' × ' + p.nh;
      else if (st.shape === 'taper') note = '↔ ' + p.tw;
      else if (st.shape === 'rounded') note = 'R ' + p.r;
      else if (st.shape === 'twowidth') note = '↔ ' + p.w2 + ' @ ' + p.t;
      if (note) extra += '<text x="' + f(VW / 2) + '" y="' + f(y + bh / 2 + 4) + '" text-anchor="middle" fill="var(--accent)" font-family="ui-monospace,monospace" font-size="11">' + note + ' ' + S.cm + '</text>';
      var dimL = st.shape === 'round' ? '' :
        '<line x1="' + f(x + bw + 14) + '" y1="' + f(y) + '" x2="' + f(x + bw + 14) + '" y2="' + f(y + bh) + '" stroke="var(--accent)"/>' +
        '<text x="' + f(x + bw + 24) + '" y="' + f(y + bh / 2) + '" fill="var(--accent)" font-family="ui-monospace,monospace" font-size="12" text-anchor="middle" transform="rotate(90 ' + f(x + bw + 24) + ' ' + f(y + bh / 2) + ')">' + l + ' ' + S.cm + '</text>';
      return '<svg viewBox="0 0 ' + VW + ' ' + VH + '" role="img" aria-label="' + (st.shape === 'round' ? 'Ø ' + w : l + ' × ' + w) + ' ' + S.cm + '">' + body + extra +
        '<line x1="' + f(x) + '" y1="' + f(y - 14) + '" x2="' + f(x + bw) + '" y2="' + f(y - 14) + '" stroke="var(--accent)"/>' +
        '<text x="' + f(VW / 2) + '" y="' + f(y - 21) + '" text-anchor="middle" fill="var(--accent)" font-family="ui-monospace,monospace" font-size="12">' + (st.shape === 'round' ? 'Ø ' : '') + w + ' ' + S.cm + '</text>' +
        dimL + (st.shape === 'round' ? '' : '<text x="' + f(VW / 2) + '" y="' + f(y + 16) + '" text-anchor="middle" fill="var(--text-muted)" font-family="ui-monospace,monospace" font-size="10">' + S.head + '</text>') + '</svg>';
    }

    function holSet(txt) { var o = {}; (String(txt || '').match(/\d{4}-\d{2}-\d{2}/g) || []).forEach(function (k) { o[k] = 1; }); return o; }
    var HOL_RO = holSet(D.dispatchHolidays), HOL_GR = holSet(D.deliveryHolidays);
    function dkey(d) { return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
    function addWorkdays(d, n, hol) { var r = new Date(d.getTime()); while (n > 0) { r.setDate(r.getDate() + 1); var k = r.getDay(); if (k !== 0 && k !== 6 && !(hol && hol[dkey(r)])) n--; } return r; }
    function eta() {
      var el = q('[data-mtm-eta]'); if (!el || !S.eta) return;
      var now = new Date(), ship = addWorkdays(now, D.leadDays, HOL_RO), a = addWorkdays(ship, D.transitMin, HOL_GR), b = addWorkdays(ship, D.transitMax, HOL_GR);
      var fmt; try { fmt = new Intl.DateTimeFormat('el-GR', { weekday: 'short', day: 'numeric', month: 'short' }); } catch (e) { fmt = null; }
      var t = function (d) { return fmt ? fmt.format(d) : d.toLocaleDateString(); };
      el.textContent = S.eta.replace('__FROM__', t(a)).replace('__TO__', t(b));
    }

    function extrasCents() {
      var c = 0, sh = shape();
      if (st.shape !== 'rect' && sh.cents) c += sh.cents;
      if (st.n > 1 && D.piece) c += D.piece.cents * (st.n - 1);
      return c;
    }

    function syncShapeUI() {
      qa('input[name="mtm-shape"]').forEach(function (i) { i.checked = i.value === st.shape; });
      qa('[data-mtm-param-for]').forEach(function (wrap) {
        wrap.hidden = wrap.getAttribute('data-mtm-param-for').split(',').indexOf(st.shape) === -1;
      });
      var lw = q('[data-mtm-dim="l"]'); if (lw) lw.hidden = st.shape === 'round';
      var wl = q('[data-mtm-dim="w"] .field__label'); if (wl) wl.textContent = (st.shape === 'round' ? S.diameter : S.width) + ' (' + S.cm + ')';
      var df = defaults();
      (PARAMS[st.shape] || []).forEach(function (k) {
        if (!st.p[k]) st.p[k] = df[k];
        var inp = q('[data-mtm-param="' + k + '"]'); if (inp && int(inp.value) !== st.p[k]) inp.value = st.p[k];
      });
      qa('input[name="mtm-pos"]').forEach(function (i) { i.checked = i.value === st.pos; });
      var pc = q('[data-mtm-pieces]'); if (pc) pc.value = String(st.n);
      /* shapes and pieces are cut from foam only: springs stay rectangular */
      if (!allowed(st.g)) {
        var to = (D.shapeGroups || []).filter(function (g) { return G[g]; });
        var pick = to.indexOf(D.shapeDefault) !== -1 ? D.shapeDefault : to[0];
        if (pick) {
          st.g = pick; st.sku = G[pick].cfg['default']; renderModels();
          try { history.replaceState(null, '', G[pick].url + location.search); } catch (e) {}
        }
      }
      qa('input[name="mtm-type"]').forEach(function (i) {
        var ok = allowed(i.value); i.disabled = !ok; i.checked = i.value === st.g;
        var card = i.closest('.opt-card'); if (card) card.classList.toggle('is-disabled', !ok);
      });
    }

    function update() {
      var ok = valid(), dok = dimsOk(), m = model(), g = group(), l = L();
      try { sessionStorage.setItem('cdrDims', JSON.stringify({ l: st.l, w: st.w })); } catch (e) {}
      ['l', 'w'].forEach(function (k) {
        var lo = k === 'l' ? lim.minL : lim.minW, hi = k === 'l' ? lim.maxL : lim.maxW;
        if (st.shape === 'round' && k === 'w') { lo = Math.max(lim.minW, lim.minL); hi = Math.min(lim.maxW, lim.maxL); }
        var bad = !(st[k] >= lo && st[k] <= hi) && !(st.shape === 'round' && k === 'l');
        var wrap = q('[data-mtm-dim="' + k + '"]'); wrap.classList.toggle('is-invalid', bad);
        q('[data-mtm-input="' + k + '"]').setAttribute('aria-invalid', bad ? 'true' : 'false');
        var hint = wrap.querySelector('.dim__hint'); if (hint) hint.textContent = lo + '–' + hi + ' ' + S.cm;
      });
      var R = ranges();
      Object.keys(R).forEach(function (k) {
        var inp = q('[data-mtm-param="' + k + '"]'); if (!inp) return;
        var on = (PARAMS[st.shape] || []).indexOf(k) !== -1, bad = on && !(st.p[k] >= R[k][0] && st.p[k] <= R[k][1]);
        var wrap = inp.closest('.field'); if (wrap) wrap.classList.toggle('is-invalid', bad);
        inp.setAttribute('aria-invalid', bad ? 'true' : 'false');
        var hint = wrap && wrap.querySelector('.dim__hint'); if (hint && dok) hint.textContent = R[k][0] + '–' + R[k][1] + ' ' + S.cm;
      });
      var msg = q('[data-mtm-msg]'), txt = '', badMsg = false;
      if (!dok) { txt = st.shape === 'round' ? S.errRound : S.errRange; badMsg = true; }
      else if (!paramsOk()) { txt = S.errParam; badMsg = true; }
      else if (st.shape !== 'round' && st.w > st.l) { txt = S.warnSwap; badMsg = true; }
      else if (st.shape !== 'rect' || st.n > 1) { txt = S.shapeNote; }
      else if (st.l > 215 || st.w < 70) { txt = S.infoTruck; }
      msg.textContent = txt; msg.hidden = !txt; msg.classList.toggle('is-bad', badMsg);

      var dp = st.p; if (!ok) { dp = defaults(); }
      q('[data-mtm-drawing]').innerHTML = ok ? drawing(l, st.w, dp) : (dok ? drawing(l, st.w, defaults()) : drawing(200, 140, defaults()));
      q('[data-mtm-ro="l"]').textContent = dok ? (st.shape === 'round' ? 'Ø ' + st.w : l) + ' ' + S.cm : '—';
      q('[data-mtm-ro="w"]').textContent = dok ? st.w + ' ' + S.cm : '—';
      q('[data-mtm-ro="h"]').textContent = m.h + ' ' + S.cm;
      q('[data-mtm-ro="a"]').textContent = ok ? shapeArea().toFixed(2).replace('.', ',') + ' m²' : '—';

      var ex = extrasCents();
      D.groups.forEach(function (gg) {
        var el = q('[data-mtm-type-price="' + gg.cfg.group + '"]'); if (!el) return;
        if (!allowed(gg.cfg.group)) { el.textContent = S.rectOnly; return; }
        if (!ok) { el.textContent = '—'; return; }
        var best = null; gg.cfg.models.forEach(function (mm) { var qq = quote(gg, mm); if (qq && (best === null || qq.cents < best)) best = qq.cents; });
        el.textContent = best === null ? S.onRequest : S.from + ' ' + money(best + ex);
      });
      g.cfg.models.forEach(function (mm) {
        var el = q('[data-mtm-model-price="' + mm.sku + '"]'); if (!el) return;
        var qq = ok ? quote(g, mm) : null; el.textContent = ok ? (qq ? money(qq.cents + ex) : S.onRequest) : '—';
      });
      qa('input[name="mtm-model"]').forEach(function (i) { i.checked = i.value === m.sku; });

      var qt = ok ? quote(g, m) : null;
      var sizeTxt = dok ? (st.shape === 'round' ? 'Ø ' + st.w : l + ' × ' + st.w) : '— × —';
      q('[data-mtm-spec]').textContent = sizeTxt + ' × ' + m.h + ' ' + S.cm;
      q('[data-mtm-model-name]').textContent = g.cfg.label + ' · ' + m.name + (st.shape !== 'rect' ? ' · ' + shape().label : '') + (st.n > 1 ? ' · ' + st.n + ' ' + S.piecesWord : '');
      q('[data-mtm-price]').textContent = qt ? money(qt.cents + ex) : (ok ? S.onRequest : '—');
      var lines = q('[data-mtm-lines]');
      if (lines) {
        lines.textContent = '';
        if (qt && ex) {
          var add = function (a, b) { var li = document.createElement('li'); var s1 = document.createElement('span'); s1.textContent = a; var s2 = document.createElement('span'); s2.className = 'num'; s2.textContent = b; li.appendChild(s1); li.appendChild(s2); lines.appendChild(li); };
          add(S.lineMattress + ' (' + l + ' × ' + st.w + ')', money(qt.cents));
          if (st.shape !== 'rect' && shape().cents) add(S.lineShape + ': ' + shape().label, money(shape().cents));
          if (st.n > 1 && D.piece) add(S.linePiece + ' × ' + (st.n - 1), money(D.piece.cents * (st.n - 1)));
        }
        lines.hidden = !lines.children.length;
      }
      var ack = q('[data-mtm-ack]');
      q('[data-mtm-submit]').disabled = !(qt && ack.checked) || st.busy;
      if (qt && !ack.checked) q('[data-mtm-error]').textContent = '';
    }

    function ref() { var s = ''; var c = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789'; for (var i = 0; i < 6; i++) s += c[Math.floor(Math.random() * c.length)]; return 'GR-' + s; }
    function props(m, qt, code) {
      var p = {}, l = L(), sh = shape();
      if (st.shape === 'round') { p[S.diameter] = st.w + ' ' + S.cm; }
      else { p[S.length] = l + ' ' + S.cm; p[S.width] = st.w + ' ' + S.cm; }
      p[S.height] = m.h + ' ' + S.cm;
      p[S.model] = m.name;
      if (st.shape !== 'rect') {
        p[S.shapeProp] = sh.label;
        if (st.shape === 'corner') { p[S.pC] = st.p.c + ' ' + S.cm; p[S.pD] = st.p.d + ' ' + S.cm; p[S.position] = S['pos_' + st.pos]; }
        if (st.shape === 'cutout') { p[S.pNw] = st.p.nw + ' ' + S.cm; p[S.pNh] = st.p.nh + ' ' + S.cm; p[S.position] = S['pos_' + st.pos]; }
        if (st.shape === 'taper') p[S.pTw] = st.p.tw + ' ' + S.cm;
        if (st.shape === 'rounded') p[S.pR] = st.p.r + ' ' + S.cm;
        if (st.shape === 'twowidth') { p[S.pW2] = st.p.w2 + ' ' + S.cm; p[S.pT] = st.p.t + ' ' + S.cm; }
      }
      if (st.n > 1) p[S.pieces] = String(st.n);
      p[S.madeToOrder] = S.yes;
      if (code) p[S.refProp] = code;
      p._model_sku = m.sku;
      p._sku_productie = m.sku + '-' + l + 'x' + st.w + (st.shape !== 'rect' ? '-' + st.shape.toUpperCase() : '') + (st.n > 1 ? '-N' + st.n : '');
      p._arie_m2 = area().toFixed(2);
      if (st.shape !== 'rect') { p._shape = st.shape; p._arie_sxima_m2 = shapeArea().toFixed(2); }
      p._tier = 'P' + pad3(qt.idx);
      p._formula_v = String(group().cfg.v);
      return p;
    }

    /* events */
    ['l', 'w'].forEach(function (k) {
      var inp = q('[data-mtm-input="' + k + '"]');
      inp.addEventListener('input', function () { st[k] = int(inp.value); update(); });
      inp.addEventListener('blur', function () { if (inp.value !== '' && !isNaN(parseInt(inp.value, 10))) inp.value = parseInt(inp.value, 10); });
    });
    qa('[data-mtm-param]').forEach(function (inp) {
      inp.addEventListener('input', function () { st.p[inp.getAttribute('data-mtm-param')] = int(inp.value); update(); });
    });
    qa('input[name="mtm-shape"]').forEach(function (i) {
      i.addEventListener('change', function () { st.shape = i.value; st.p = {}; syncShapeUI(); update(); });
    });
    qa('input[name="mtm-pos"]').forEach(function (i) { i.addEventListener('change', function () { st.pos = i.value; update(); }); });
    var pcs = q('[data-mtm-pieces]');
    if (pcs) pcs.addEventListener('change', function () { st.n = int(pcs.value) || 1; syncShapeUI(); update(); });
    qa('[data-mtm-preset]').forEach(function (b) {
      b.addEventListener('click', function () {
        var p = b.getAttribute('data-mtm-preset').split('x'); st.l = int(p[0]); st.w = int(p[1]);
        q('[data-mtm-input="l"]').value = st.l; q('[data-mtm-input="w"]').value = st.w; update();
      });
    });
    qa('input[name="mtm-type"]').forEach(function (i) {
      i.addEventListener('change', function () {
        if (!G[i.value] || !allowed(i.value)) return;
        st.g = i.value; st.sku = G[i.value].cfg['default']; renderModels(); update();
        try { history.replaceState(null, '', G[i.value].url + '?l=' + st.l + '&w=' + st.w + (st.shape !== 'rect' ? '&shape=' + st.shape : '') + (st.n > 1 ? '&n=' + st.n : '')); } catch (e) {}
      });
    });
    q('[data-mtm-ack]').addEventListener('change', update);
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var m = model(), qt = valid() && allowed(st.g) ? quote(group(), m) : null, err = q('[data-mtm-error]'), btn = q('[data-mtm-submit]');
      if (!qt) return;
      if (!q('[data-mtm-ack]').checked) { err.textContent = S.ackRequired; return; }
      err.textContent = '';
      var sh = shape(), code = (st.shape !== 'rect' || st.n > 1) ? ref() : '';
      var items = [{ id: qt.id, quantity: 1, properties: props(m, qt, code) }];
      var forTxt = m.name + ' ' + (st.shape === 'round' ? 'Ø ' + st.w : L() + ' × ' + st.w) + ' ' + S.cm;
      var linked = function () { var o = {}; o[S.forMattress] = forTxt; o[S.refProp] = code; o[S.madeToOrder] = S.yes; o._mtm_ref = code; return o; };
      if (st.shape !== 'rect' && sh.variant) items.push({ id: sh.variant, quantity: 1, properties: linked() });
      if (st.n > 1 && D.piece && D.piece.variant) items.push({ id: D.piece.variant, quantity: st.n - 1, properties: linked() });
      var body = { items: items };
      st.busy = true; btn.disabled = true; var label = btn.textContent; btn.textContent = S.adding;
      var done = function () { st.busy = false; btn.textContent = label; update(); };
      if (window.themeAddToCart) {
        window.themeAddToCart(body, btn).then(done, done);
      } else {
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { if (!r.ok) throw r; location.href = '/cart'; })
          .catch(function () { done(); });
      }
    });

    q('[data-mtm-input="l"]').value = st.l;
    q('[data-mtm-input="w"]').value = st.w;
    renderModels(); syncShapeUI(); eta(); update();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-mtm]').forEach(function (root) {
      if (root.dataset.mtmReady) return; root.dataset.mtmReady = '1'; init(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
